export default __webpack_public_path__ + "static/vremenagroteskbold-59885cbcee12de5ee5bf28d011657246.otf";